import { useTranslation } from 'react-i18next';
import { FaDownload, FaEye } from 'react-icons/fa';

import { useFileDownload } from 'hooks';
import { MenuOption } from 'types';

export const useDocumentMenuOptions = (): MenuOption[] => {
  const { t } = useTranslation('case_details_plans');
  const { downloadConsultationDocument, openConsultationDocument } = useFileDownload();

  return [
    {
      label: t('view_button', 'View'),
      icon: FaEye,
      onClick: (consultation, document) => openConsultationDocument(document),
    },
    {
      label: t('download_button', 'Download copy'),
      icon: FaDownload,
      onClick: (consultation, document) => downloadConsultationDocument(document),
    },
  ];
};
